/**
 * baseUrlParams contains the default parameters to keep when reducing
 * the given query object in getUrlQuery.
 */
export const baseUrlParams = ['q', 'sfs', 'sfn', '_sp'];

/**
  * Extracts the query (q), safe-search (sfs, sfn) from the url query.
  * Will also add the snowplow user id to the query if inside our mobile native apps.
  *
  * @param {Object} query contains the query object to extract the information from.
  * @param {Object} user store data to take into consideration for additional information.
  * @param {Array} urlParams defaults to baseUrlParams if none are given
  */
export const getUrlQuery = (query = {}, user, urlParams = baseUrlParams) => {
  let urlQuery = query;

  // if we are inside our native mobile apps
  // and the user has a Snowplow user id,
  // we need to append it to the URL so Snowplow
  // can read and evaluate it when switching verticals
  if (user?.isEcosiaApp && user?.appUserSnowplowId) {
    urlQuery = {
      ...query,
      _sp: user.appUserSnowplowId,
    };
  }

  const result = urlParams
    .reduce((acc, key) => {
      const value = urlQuery[key];
      return value ? { ...acc, [key]: value } : acc;
    }, {});

  return result;
};
